import React from 'react';
import { ErrorMessage, Field } from '@atlaskit/form';
import Select, { ValueType } from '@atlaskit/select';

import { LangCodes, LevelsInfo, Translations } from '../../interfaces';
import { IS_LEVEL_NAME_SEARCH } from '../../utils/constants';
import { getOptionLabel } from '../../utils/levelModelUtils';
import { getLevelInfoIfExists } from '../../utils/levelRenderUtils';

export type OptionTranslated = {
    label: string;
    value: string;
    isDefaultOption?: boolean;
    isEnabled?: boolean;
    nextSelect?: SelectTranslated;
    translation?: Partial<Translations>;
};

export type SelectTranslated = {
    label: string;
    name: string;
    options: OptionTranslated[];
};

export const FieldSelect = ({
    select,
    selectsValues,
    handleOnChange,
    locale,
    levelsInfo,
    isLicenseActive,
    appearance,
    spacing,
}: {
    appearance: 'subtle' | 'default';
    handleOnChange: any;
    isLicenseActive: boolean;
    levelsInfo: LevelsInfo;
    locale: LangCodes | undefined;
    select: SelectTranslated;
    selectsValues: Map<string, OptionTranslated>;
    spacing: 'compact' | 'default';
}) => (
    <Field<ValueType<OptionTranslated>>
        name={select.name}
        label={''}
    >
        {({ fieldProps, error }) => (
            <>
                {getLevelInfoIfExists(select, selectsValues, levelsInfo, locale)}
                <Select<OptionTranslated>
                    className='multi-select'
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            borderWidth: state.isFocused ? '2px' : appearance === 'subtle' ? '2px' : '1px',
                        }),
                    }}
                    isClearable
                    placeholder='Select option'
                    appearance={appearance}
                    spacing={spacing}
                    getOptionLabel={(option: OptionTranslated) => getOptionLabel(option, locale)}
                    value={selectsValues.get(select.name)}
                    options={select.options}
                    onChange={handleOnChange(select)}
                    name={select.name}
                    label=''
                    isDisabled={!isLicenseActive}
                />
                {getLevelInfoIfExists(select, selectsValues, levelsInfo, locale, !IS_LEVEL_NAME_SEARCH)}
                {error && <ErrorMessage>You must select at least 1 issue!</ErrorMessage>}
            </>
        )}
    </Field>
);
